import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Install the window.storage shim BEFORE App is imported / mounted. The legacy
// loadS / saveS helpers at the top of App.jsx (lines 17–18) read window.storage
// during the initial useEffect, so the shim must exist before render.
import { storage } from './lib/storage.js';
window.storage = storage;

import App from './App.jsx';
import { AuthGate } from './lib/auth.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthGate>
      {({ user, logout }) => <App user={user} onLogout={logout} />}
    </AuthGate>
  </StrictMode>,
);
